module.exports = __webpack_public_path__ + "static/img/sys.177accf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys.png
// module id = Gnoi
// module chunks = 0